export interface LoaderProps {}

export const useLoader = (props: LoaderProps) => {
  return {
    ...props,
  }
}
